import React from 'react'
import { GetETypeName } from '../../../../configurations/enums/EType.js'
import { CHECK_URL } from '../../../../configurations/initUrls.js'
import { getLoginInfo } from '../../../../configurations/auth/getLoginInfo.js'
import QRCode from 'react-qr-code'
import moment from 'moment'

// koi bhi page size + margin none — page jo bhi ho, layout usme fit ho jayega
const PRINT_CSS = `
  @page {
    size: auto;              /* user jo paper chune — A4 / Letter / A5 / Legal */
    margin: 0 !important;    /* margin none default */
  }

  @media print {
    html, body {
      width: auto !important;
      height: auto !important;
      margin: 0 !important;
      padding: 0 !important;
      background: #fff !important;
      -webkit-print-color-adjust: exact !important;
      print-color-adjust: exact !important;
    }

    .rx-print-page {
      width: 100% !important;
      max-width: none !important;
      /* 2mm kam — warna rounding se ek khali page aa jata hai */
      min-height: calc(100vh - 2mm) !important;
      box-sizing: border-box !important;
      padding: 10mm !important;   /* printer ka non-printable area cover */
      margin: 0 !important;
      border: 0 !important;
      -webkit-print-color-adjust: exact !important;
      print-color-adjust: exact !important;
    }

    .rx-print-page img,
    .rx-print-page svg { display: block; max-width: 100% !important; }

    /* rows/table beech se toot ke aadhi doosre page par na jaye */
    .rx-print-page table,
    .rx-print-page tr,
    .rx-print-page .rx-keep { page-break-inside: avoid; break-inside: avoid; }
  }
`

export const ConfirmOpdPrint = React.forwardRef((props, ref) => {
    const data = props.printData
    const userData = getLoginInfo()

    const patientName = (data?.patientName || "").toUpperCase()

    return (
        <div ref={ref}>
            <style type="text/css">{PRINT_CSS}</style>

            {userData && data &&
                <div className='rx-print-page bg-white flex flex-col w-full mx-auto p-6' style={{ maxWidth: "210mm", minHeight: "100vh", boxSizing: "border-box" }}>

                    {/* HEADER */}
                    <div className="rx-keep w-full flex justify-between items-center">
                        <div>
                            <h3 className="text-xl font-semibold text-gray-800">
                                Dr. {userData.fullName}
                            </h3>
                            <div>
                                <h3 className="text-[11px]">
                                    {userData.specialisation?.name} ({userData.specialisation?.shortName})
                                </h3>
                                <h3 className="text-[11px]">
                                    {userData.degree}
                                </h3>
                            </div>
                        </div>
                        <div className="flex flex-col items-center">
                            <QRCode size={50} value={CHECK_URL + data.id} />
                            <p className="text-xs text-gray-600 mt-1">Scan to check</p>
                        </div>
                    </div>

                    {/* BODY — bachi hui height le lega, chhote page par bhi shrink ho jayega */}
                    <div className='text-[11px] grow'>
                        <div className="mt-2">
                            <table className="table-auto w-full border border-gray-300">
                                <tbody>
                                    <tr className="border-b">
                                        <td className="px-2 py-1 border border-gray-300">Ref No: <span className='font-semibold'>{data.id}/{data.registeredIdForRef}</span></td>
                                        <td className="px-2 py-1 border border-gray-300">Confirm Number: <span className='text-sm font-bold'>{data.confirmedAllotedNumber}</span>{data.confirmedAllotedNumber == data.opdNumberAlloted ? "" : "/" + data.opdNumberAlloted}</td>
                                    </tr>
                                    <tr className="border-b">
                                        <td className="px-2 py-1 border border-gray-300">Patient Name</td>
                                        <td className="px-2 py-1 border border-gray-300 font-bold">{patientName}</td>
                                    </tr>
                                    <tr className="border-b bg-gray-50">
                                        <td colSpan={2} className="px-2 py-1 border border-gray-300 text-center">
                                            <span className="mr-4">BP: <span className='font-bold'>{data.bloodPressure}</span></span>
                                            <span className="mr-4">Weight: <span className='font-bold'>{data.weight}Kg</span></span>
                                            <span className="mr-4">Age: <span className='font-bold'>{data.age}Y</span></span>
                                            <span className="mr-4">BG: <span className='font-bold'>{data.bloodGroup}</span></span>
                                        </td>
                                    </tr>
                                    <tr className="border-b bg-gray-50">
                                        <td className="px-2 py-1 border border-gray-300">Type</td>
                                        <td className="px-2 py-1 border border-gray-300 font-bold">{GetETypeName(data.type)}</td>
                                    </tr>
                                    <tr className="border-b">
                                        <td className="px-2 py-1 border border-gray-300">Mobile</td>
                                        <td className="px-2 py-1 border border-gray-300">{data.mobile}</td>
                                    </tr>
                                    <tr className="border-b">
                                        <td className="px-2 py-1 border border-gray-300">Address</td>
                                        <td className="px-2 py-1 border border-gray-300">{data.patientAddress}</td>
                                    </tr>
                                    <tr className="border-b bg-gray-100">
                                        <td className="px-2 py-1 border border-gray-300">Date</td>
                                        <td className="px-2 py-1 border border-gray-300">{moment(data.onDate).format("DD-MM-YYYY")}</td>
                                    </tr>
                                    <tr className="border-b bg-gray-100">
                                        <td className="px-2 py-1 border border-gray-300">Timing</td>
                                        <td className="px-2 py-1 border border-gray-300">
                                            {data.opdCenter && `${moment(data.opdCenter.opdStartTime).format("LT")} to ${moment(data.opdCenter.opdEndTime).format("LT")}`}
                                        </td>
                                    </tr>
                                    <tr className="border-b bg-gray-100">
                                        <td className="px-2 py-1 border border-gray-300">Center</td>
                                        <td className="px-2 py-1 border border-gray-300 font-semibold">{data.opdCenter?.centerName}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>

                    {/* FOOTER — page ke bilkul neeche */}
                    <div className='rx-keep w-full flex items-center justify-between text-[11px] pt-3'>
                        <div>
                            Signature ________________________
                        </div>
                        <div className='flex flex-col items-center'>
                            <span className='text-[8px]'>Powered By</span>
                            <img className="h-3 w-auto" src="/assets/images/logo.png" alt="logo" />
                        </div>
                    </div>
                </div>
            }
        </div>
    )
})